module.exports = __webpack_public_path__ + "img/image (1).43d6cca5.jpeg";